const leaflets = {
    "aeo": {
        "config": {
            "primary-color": "#E32128",
            "secondary-color": "#4480C9",
            "tertiary-color": "rgb(99, 44, 56)",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/logo_aeo.png"),
            "serverPath": "aeodemo.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di A&O!",
            "shareFlyerURL": "https://aeodemo.volantinointerattivo.net?v=410",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "A&O | Volantino Interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino. Offerte valide dal 18/05 al 29/05",
            "ogImageMeta": "https://aeodemo.volantinointerattivo.net/media/images/aeo_fb_.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "UA-152069090-",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 20,
            "client_id": 27,
            "signboard_id": 44,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet",
            "version": 410
        },
        "leaflet": {
            "name": "Demo A&O",
            "code": "410",
            "id_campaign": "410",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/Indice-aeo_K8AMUZc.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 28.262925889756946,
                            "left": 9.843106192129628,
                            "width": 76.75462962962962,
                            "height": 7.006171332465277
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 35.02534195644404,
                            "left": 9.813355431871823,
                            "width": 76.75462962962962,
                            "height": 7.006171332465276
                        }
                    },
                    {
                        "page": 6,
                        "blueprint": {
                            "top": 41.877116683261846,
                            "left": 9.779058727078795,
                            "width": 76.75462962962962,
                            "height": 7.006171332465276
                        }
                    },
                    {
                        "page": 8,
                        "blueprint": {
                            "top": 48.692489723754086,
                            "left": 10.312622123502178,
                            "width": 76.75462962962962,
                            "height": 7.006171332465276
                        }
                    },
                    {
                        "page": 10,
                        "blueprint": {
                            "top": 55.65679386446419,
                            "left": 9.590441034631446,
                            "width": 76.75462962962962,
                            "height": 7.006171332465276
                        }
                    },
                    {
                        "page": 12,
                        "blueprint": {
                            "top": 62.566246149067275,
                            "left": 9.97170465118918,
                            "width": 76.75462962962962,
                            "height": 7.006171332465276
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://interattivo.net",
                        "target": "_blank",
                        "blueprint": {
                            "top": 7.11247886728656,
                            "left": 63.58269935193012,
                            "width": 30.0,
                            "height": 5.555262045646662
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Dispensa",
                        "Snack Dolci",
                        "Colazione",
                        "Olio",
                        "Rossi",
                        "Pasta",
                        "Snack Salati"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Gelati",
                        "Panati",
                        "Preparati",
                        "Verdure"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Yogurt",
                        "Formaggi",
                        "Vegetali",
                        "Latte",
                        "Pasta",
                        "Salumi",
                        "Ittico",
                        "Snack"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Formaggi",
                        "Salumi"
                    ]
                },
                {
                    "category_name": "Ortofrutta",
                    "subcategories": [
                        "Frutta",
                        "Verdura"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Bovino",
                        "Suino",
                        "Altro",
                        "Avicoli"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Bibite",
                        "Liquori",
                        "Vini e Spumanti",
                        "Birre",
                        "Acqua",
                        "Succhi"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Intima",
                        "Corpo"
                    ]
                },
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Bucato",
                        "Stoviglie",
                        "Extra",
                        "Superfici"
                    ]
                },
                {
                    "category_name": "Casa e Cucina",
                    "subcategories": [
                        "Altro"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_1_iaoWPXz.jpg",
                    "products": [
                        {
                            "item_id": "200973",
                            "field1": "50 Cialde Audace",
                            "field2": "KOSÈ",
                            "field3": "",
                            "field4": "",
                            "description": "50 Cialde Audace KOSÈ",
                            "grammage": 0,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.41149165904936,
                                "left": 4.68730956733699,
                                "width": 26.20353443022547,
                                "height": 45.132541133455206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Kose_3d_facing_1498119821_1509008326_1575657507.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cialde_1553621163_1558685581_1575657508.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_ISirrYH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "200972",
                            "field1": "Latte UHT Parzialmente Scremato",
                            "field2": "SELEX",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "Latte UHT Parzialmente Scremato SELEX lt. 1",
                            "grammage": 0,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.57236917276051,
                                "left": 4.68730956733699,
                                "width": 26.20353443022547,
                                "height": 45.132541133455206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/497312_selex_latte_UHT_1573571488_1575657485.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_p98U7vc_fQ47euJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Latte",
                                        "testo": "I prodotti della linea base Selex sono oltre 3.000 e comprendono tutto quello che serve, ogni giorno, per la casa e la famiglia. Alimentari freschi, formaggi e latticini, salumi, specialità di gastronomia, pasta, gelati, surgelati, e poi tutti i prodotti di drogheria le soluzioni più nuove per l'igiene e la cura del corpo, ma anche per la pulizia della casa, fino agli accessori per la cucina, la tavola e a tanti altri articoli che risolvono le necessità di ogni giorno. Per non dire dei prodotti dedicati ai nostri amici animali. (Fonte: prodottiselex.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/497312_selex_latte_UHT_1573571488_1575657485.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "126701",
                            "field1": "Cornetto",
                            "field2": "ALGIDA x5",
                            "field3": "g. 375",
                            "field4": "",
                            "description": "Cornetto ALGIDA x5 g. 375",
                            "grammage": 375,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 4.182972463436928,
                                "left": 69.40394576477757,
                                "width": 26.20353443022547,
                                "height": 45.132541133455206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Cornetto_Classico_1517247193_1521568649.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_F10jsIk_K5ULTgo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/cornetto_algida.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "18341",
                            "field1": "Yogurt alla Frutta",
                            "field2": "PARMALAT",
                            "field3": "g. 125 x 2",
                            "field4": "",
                            "description": "Yogurt alla Frutta PARMALAT g. 125 x 2",
                            "grammage": 250,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 50.800888368372945,
                                "left": 69.40394576477757,
                                "width": 26.20353443022547,
                                "height": 45.13254113345521
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/447229_PARMALAT.YOG.VELL.FRAG.GR125X2_1605198716.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_8BEJ5zk_t6ZAEhy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Yogurt fragola",
                                        "testo": "Tutta la bontà del latte e della frutta nel nostro yogurt alla fragola. Concediti tutto l'anno il delizioso sapore e la dolcezza della fragola insieme alla cremosità dello yogurt. Ideale sia per piacevoli pause sane e gustose che come alimento nutriente ed equilibrato per colazione e per finire i propri pasti. (Fonte: parmalat.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/447229_PARMALAT.YOG.VELL.FRAG.GR125X2_1605198716.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_2_ipzEDso.jpg",
                    "products": [
                        {
                            "item_id": "5541",
                            "field1": "AURICCHIO",
                            "field2": "PICCANTE",
                            "field3": "",
                            "field4": "",
                            "description": "AURICCHIO PICCANTE",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 5.21130884369287,
                                "left": 4.0779250457038385,
                                "width": 46.922608165752585,
                                "height": 22.73765996343693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/445077_auricchio_provolone_semipiccante_1603900360.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/auricchio_1620225851.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_OVKZj5m_RrKhHge.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Auricchio",
                                        "testo": "Consigliato anche come aperitivo, grattugiato sulla pasta o a scaglie sul carpaccio fresco. è considerato uno tra i più famosi e apprezzati formaggi tipici italiani. Scopri tutti i suggerimenti Auricchio nelle nostre ricette: per una cena tra amici servi le buonissime penne alla mediterranea con il nostro Provolone tagliato a dadini, oppure per un aperitivo informale ti consigliamo i divertenti Muffin salati con Provolone e pancetta. (Fonte: auricchio.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/445077_auricchio_provolone_semipiccante_1603900360.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "89175",
                            "field1": "STRACCHINO",
                            "field2": "MASSERIA",
                            "field3": "ALTA QUALITÀ",
                            "field4": "",
                            "description": "STRACCHINO MASSERIA ALTA QUALITÀ",
                            "grammage": 0,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 27.948968807129802,
                                "left": 4.0779250457038385,
                                "width": 46.922608165752585,
                                "height": 22.966179159049357
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/stracchino_crescenza_piatto.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/LOGO_LATTE_MASSERIA_VERDE_1488804016.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_chwnIG2_gFHJs4m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "184173",
                            "field1": "PARMIGIANO REGGIANO",
                            "field2": "DOP",
                            "field3": "STAGIONATO 24 MESI",
                            "field4": "",
                            "description": "PARMIGIANO REGGIANO DOP STAGIONATO 24 MESI",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 7.3822412020109685,
                                "left": 51.00053321145643,
                                "width": 46.92260816575259,
                                "height": 43.53290676416819
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/445060_Parmigiano_ReggianoDOK_1488532569_1562139990_1562140089_1562160327.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/parm_reg_1573832412_1607682070.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/logo_parmigiano_reggiano_1526023058_1574760211_1607682083.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_Fe6n3wg_m3AuRdH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Parmigiano reggiano",
                                        "testo": "Il Parmigiano Reggiano stagionato 22-24 mesi ha raggiunto l'età ottimale per essere degustato ed esprimere al naso e al palato una ricchezza di odori e aromi in perfetto equilibrio e armonia. (Fonte: montecoppe.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/parm_reg_1573832412_1607682070.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "45650",
                            "field1": "GORGONZOLA DOP ",
                            "field2": "SPECIALITÀ AL CUCCHIAIO",
                            "field3": "",
                            "field4": "",
                            "description": "GORGONZOLA DOP  SPECIALITÀ AL CUCCHIAIO",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 50.91514796617916,
                                "left": 51.00053321145643,
                                "width": 46.92260816575259,
                                "height": 22.39488117001828
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/gr-igor_1513173478.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Gorgonzola_al_cucchiaio_Gran_Riserva_DOP_DOK__1549010133_1606205188.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_qgz35BF_SgS20kV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5791",
                            "field1": "CACIOTTA",
                            "field2": "DI NORCIA",
                            "field3": "",
                            "field4": "",
                            "description": "CACIOTTA DI NORCIA",
                            "grammage": null,
                            "price": "1.23",
                            "price_label": "€ 1,23 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 50.91514796617916,
                                "left": 2.6154021937842775,
                                "width": 48.385131017672144,
                                "height": 22.39488117001828
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/447368_caciotta_di_norcia_DOK_1601364119.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_vfip2iY_4RBWQel.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5467",
                            "field1": "PECORINO DA TAVOLA",
                            "field2": "PASTORINO SARDO",
                            "field3": "",
                            "field4": "",
                            "description": "PECORINO DA TAVOLA PASTORINO SARDO",
                            "grammage": 0,
                            "price": "1.25",
                            "price_label": "€ 1,25 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 73.31002913619744,
                                "left": 2.6154021937842775,
                                "width": 48.385131017672144,
                                "height": 22.39488117001828
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/445095_pastore_del_sardo_DOK_1619767475_1620137506.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_3YWt4Mk_E6QuEIq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "20514",
                            "field1": "BAYERNLAND",
                            "field2": "FONTAL",
                            "field3": "",
                            "field4": "",
                            "description": "BAYERNLAND FONTAL",
                            "grammage": null,
                            "price": "0.63",
                            "price_label": "€ 0,63 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 73.31002913619744,
                                "left": 51.00053321145643,
                                "width": 48.14632845825716,
                                "height": 22.39488117001828
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/bayernland_Fontal_1620376429.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_jhF7Ipi_OiG37Pt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_3_I6REl86.jpg",
                    "products": [
                        {
                            "item_id": "171958",
                            "field1": "SALAME UNGHERESE",
                            "field2": "SAPER DI SAPORI ",
                            "field3": "",
                            "field4": "",
                            "description": "SALAME UNGHERESE SAPER DI SAPORI ",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 7.267981604204754,
                                "left": 1.8841407678244972,
                                "width": 49.23826934795856,
                                "height": 43.30438756855575
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/salame_ungherese_tagliere_1619777550.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/salame_ungherese_ambientata_1619777551.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_SUrKOxy_WCHnlnB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Rosette di sfoglia con salame e formaggio",
                                    "data": {
                                        "ingredients": "1 rotolo pasta sfoglia (rettangolare), 100 g salame tipo Milano, 4 fette formaggio (fila e fondi), q.b. latte",
                                        "recipe": "Accendete il forno a 180° in modalità ventilata oppure 190° in modalità statica. Foderate una teglia di 26 cm con carta da forno bagnata e strizzata. Srotolate sul piano di lavoro il rotolo di pasta sfoglia; sistemate le fette di salame leggermente accavallate le une sulle altre poi sopra al salame aggiungete le fette di formaggio tagliate a metà. Arrotolate in un cilindro ben compatto partendo dal lato più corto poi con un coltello ben affilato tagliate il cilindro a fette della stessa misura più o meno. Sistemate ogni fetta all’interno della teglia distanziandole q/b; spennellate la superficie di ogni fetta con il latte (non freddo) poi infornate per la cottura di circa 25'. (il tempo indicato è soggettivo e in base alla tipologia del vostro forno). Le rosette di sfoglia con salame e formaggio saranno cotte a puntino qualora diventino dorate e gonfie. Sfornate lasciatele intiepidire e servite a piacere. (Fonte: blog.giallozafferano.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/1_dWOHsvq.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "208666",
                            "field1": "PROSCIUTTO DI PARMA DOP",
                            "field2": "SAPER DI SAPORI",
                            "field3": "STAGIONATO 18 MESI",
                            "field4": "",
                            "description": "PROSCIUTTO DI PARMA DOP SAPER DI SAPORI STAGIONATO 18 MESI",
                            "grammage": 0,
                            "price": "2.19",
                            "price_label": "€ 2,19 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 7.267981604204754,
                                "left": 51.122410115783055,
                                "width": 44.85070079219988,
                                "height": 43.304387568555754
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/prosciutto_parma_1555686893_1585041889.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/saper_di_sapori_logo_1554306257_1560331095_1585041889.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/logo_prosciutto_di_parma_trasparente_1579538164_1585041889.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/crudo_saper_di_sapori__1600337595.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/crudo_saper_di_sapori_1600756523.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_U0Wph48_kHhKw0L.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Purea di avocado, uova in camicia e Prosciutto di Parma",
                                    "data": {
                                        "ingredients": "2 fette spesse di pane tipo casereccio o pane al lievito madre, 1 avocado grande e maturo, sbucciato e senza nocciolo, Qualche goccia di succo di limone, 2 uova, 6 fette di Prosciutto di Parma, Foglie di rucola, Olio d’oliva e aceto balsamico, Pepe nero appena macinato",
                                        "recipe": "Fate abbrustolire il pane. Nel frattempo, prendete l’avocado e schiacciatelo con una forchetta aggiungendovi qualche goccia di succo di limone e del pepe nero per insaporire. Spalmate abbondantemente la purea sulle fette di pane abbrustolito. Preparate le uova in camicia sbollentandole in acqua calda per 2-3 minuti oppure fintantoché non avranno raggiunto il punto di cottura da voi desiderato. Scolate bene le uova e disponetele sulle fette di pane. Affianco alle fette di pane adagiate il Prosciutto di Parma e le foglie di rucola. Innaffiate con un po’ d’olio d’oliva e aceto balsamico. Servite quindi insaporito con del pepe nero appena macinato. (Fonte: prosciuttodiparma.com)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/108_Avocado-and-Parma-575x450.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "241426",
                            "field1": "FESA DI MANZO FUMÈ",
                            "field2": "PUNTA D'ANCA",
                            "field3": "SENZA GLUTINE E LATTOSIO",
                            "field4": "",
                            "description": "FESA DI MANZO FUMÈ PUNTA D'ANCA SENZA GLUTINE E LATTOSIO",
                            "grammage": 0,
                            "price": "1.43",
                            "price_label": "€ 1,43 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 50.57236917276051,
                                "left": 48.928625837903716,
                                "width": 47.04448507007922,
                                "height": 22.73765996343693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/BEEF_FUME_PIATTO__TAGLIERE_1607627729.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_rXMaEx4_Akyou2K.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5547",
                            "field1": "MORTADELLA BOLOGNA IGP",
                            "field2": "FELSINEO LA BLU",
                            "field3": "senza glutine e lattosio",
                            "field4": "",
                            "description": "MORTADELLA BOLOGNA IGP FELSINEO LA BLU senza glutine e lattosio",
                            "grammage": 0,
                            "price": "0.79",
                            "price_label": "€ 0,79 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 50.90550731261426,
                                "left": 0.0,
                                "width": 48.890920170627666,
                                "height": 22.412020109689212
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Felsineo_La_Blu_mortadella_Bologna_IGP_DOK_1600186354.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_qfgTlm8_n0n2tcB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5552",
                            "field1": "ARROSTO DI POLLO",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "ARROSTO DI POLLO",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.31752742230347,
                                "left": 0.0,
                                "width": 48.890920170627666,
                                "height": 22.949040219378425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/447492_Arrosto_di_pollo_DOK_1611855270.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_0NWxUFP_GC06Pdm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258529",
                            "field1": "CULATTA COTTA",
                            "field2": "AL FORNO",
                            "field3": "senza glutine e lattosio",
                            "field4": "",
                            "description": "CULATTA COTTA AL FORNO senza glutine e lattosio",
                            "grammage": 0,
                            "price": "0.98",
                            "price_label": "€ 0,98 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.31752742230347,
                                "left": 48.890920170627666,
                                "width": 50.80438756855576,
                                "height": 22.949040219378425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/453034_CULATTA_COTTA_AL_FORNO_PZ2_1619777483.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_Xmc93WH_tY5tvJi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_4_xPzzPuO.jpg",
                    "products": [
                        {
                            "item_id": "253094",
                            "field1": "ANANAS HONEYGLOW",
                            "field2": "DEL MONTE",
                            "field3": "",
                            "field4": "",
                            "description": "ANANAS HONEYGLOW DEL MONTE",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 12.066884712065812,
                                "left": 4.68730956733699,
                                "width": 25.106642291285798,
                                "height": 49.017367458866545
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/ananas_del_monte_1611662045_1615277914.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_kz73YJp_CSjhVtS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.delmonteeurope.it/prodotti/frutta-e-verdure-freschi/ananas-gold.htm"
                                }
                            ]
                        },
                        {
                            "item_id": "30993",
                            "field1": "ANGURIE ",
                            "field2": "BABY ROSSE",
                            "field3": "",
                            "field4": "",
                            "description": "ANGURIE  BABY ROSSE",
                            "grammage": 0,
                            "price": "0.99",
                            "price_label": "€ 0,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 12.066884712065812,
                                "left": 29.79395185862279,
                                "width": 20.59719683120049,
                                "height": 49.017367458866545
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Anguria_baby_con_semi_1431966768.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_XjPOUfY_1KRGeyx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "249524",
                            "field1": "FRAGOLE MATERA",
                            "field2": "g. 400",
                            "field3": "",
                            "field4": "",
                            "description": "FRAGOLE MATERA g. 400",
                            "grammage": 400,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 61.08425217093236,
                                "left": 4.68730956733699,
                                "width": 45.70383912248629,
                                "height": 17.481718464351005
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/443120_FRAGOLE_MATERA_GR._400_1613032808_1613058730.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_3zs6mP5_kdTOKuA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "6135",
                            "field1": "NESPOLE",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "NESPOLE",
                            "grammage": 0,
                            "price": "2.99",
                            "price_label": "€ 2,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 78.56597063528336,
                                "left": 4.68730956733699,
                                "width": 45.70383912248629,
                                "height": 17.02468007312614
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Nespole_shutter_AO.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_UUzXg8u_WF34KFS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "28559",
                            "field1": "ZUCCHINE",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "ZUCCHINE",
                            "grammage": 0,
                            "price": "0.99",
                            "price_label": "€ 0,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 11.609846320840951,
                                "left": 51.73179463741621,
                                "width": 46.31322364411943,
                                "height": 16.79616087751371
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/zucchine_1487238293.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_gSGqnFN_Otyr2HY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "181061",
                            "field1": "POMODORI VERDE",
                            "field2": "F. LLI LA PIETRA",
                            "field3": "g. 500",
                            "field4": "",
                            "description": "POMODORI VERDE F. LLI LA PIETRA g. 500",
                            "grammage": 500,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 28.40600719835466,
                                "left": 51.73179463741621,
                                "width": 46.31322364411943,
                                "height": 15.882084095063984
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/la_pietra_pomodori_verdi_1559558500.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_MxHMWGL_XxQ5iD5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "http://www.fratellilapietra.it/it/azienda/prodotti/55-verde-qualita.html"
                                }
                            ]
                        },
                        {
                            "item_id": "28553",
                            "field1": "CAROSELLI",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "CAROSELLI",
                            "grammage": 0,
                            "price": "1.29",
                            "price_label": "€ 1,29 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 44.288091293418645,
                                "left": 51.73179463741621,
                                "width": 46.31322364411943,
                                "height": 14.16819012797075
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/caroselli_1560267413.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_DelkCOt_Cnah7Bg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "31011",
                            "field1": "INSALATA POKER",
                            "field2": "SELEX",
                            "field3": "g. 200",
                            "field4": "",
                            "description": "INSALATA POKER SELEX g. 200",
                            "grammage": 200,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 58.45628142138939,
                                "left": 51.73179463741621,
                                "width": 46.31322364411943,
                                "height": 14.968007312614258
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/selex_insalata_poker_1570175723.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Selex_chiama_natura_1577098248.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_d3nJV6O_3CQwLNB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258561",
                            "field1": "Verdure Grigliate",
                            "field2": "SELEX",
                            "field3": "g. 250",
                            "field4": "",
                            "description": "Verdure Grigliate SELEX g. 250",
                            "grammage": 250,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 73.42428873400365,
                                "left": 51.73179463741621,
                                "width": 46.31322364411943,
                                "height": 22.73765996343693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/selex_grigliati_zucchine_250gr_1538156449_1619773900.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/selex_grigliati_peperoni_250gr_1538156450_1619773901.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_zqf0JrH_764o49B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_5_klApOwL.jpg",
                    "products": [
                        {
                            "item_id": "258531",
                            "field1": "CUORE DI REALE",
                            "field2": "BOVINO UK/ IRLANDA",
                            "field3": "",
                            "field4": "",
                            "description": "CUORE DI REALE BOVINO UK/ IRLANDA",
                            "grammage": 0,
                            "price": "11.90",
                            "price_label": "€ 11,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Bovino UK",
                                "Bovino Irlanda"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 3.7162934186471666,
                                "left": 1.9713589274832417,
                                "width": 46.69713589274832,
                                "height": 48.234689213893965
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/shutterstock_1687518379_1620290075.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_nOq0ZZ1_gFOoRt0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258530",
                            "field1": "\"I MEDAGLIONI\"",
                            "field2": "FILETTO DI SUINO",
                            "field3": "al pepe in grani",
                            "field4": "",
                            "description": "\"I MEDAGLIONI\" FILETTO DI SUINO al pepe in grani",
                            "grammage": 0,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 5.4301873857404015,
                                "left": 48.91224862888482,
                                "width": 51.08775137111517,
                                "height": 23.32609689213894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/filetto_di_suino_al_pepe_1619768107.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_nk9Nhwq_RWY6rYo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5802",
                            "field1": "- CAPOCOLLO CON OSSO - costate",
                            "field2": "DI SUINO",
                            "field3": "",
                            "field4": "",
                            "description": "- CAPOCOLLO CON OSSO - costate DI SUINO",
                            "grammage": 0,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Capocollo con osso",
                                "Costate"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 28.756284277879338,
                                "left": 48.91224862888482,
                                "width": 51.08775137111517,
                                "height": 23.40607861060329
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/22011_suino_capocollo_osso_DOK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_ITqmCX2_QvDGOKG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258538",
                            "field1": "Hamburger di Scottona",
                            "field2": "MIDELIZIA",
                            "field3": "g. 300",
                            "field4": "",
                            "description": "Hamburger di Scottona MIDELIZIA g. 300",
                            "grammage": 300,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 52.16236288848263,
                                "left": 73.0438756855576,
                                "width": 23.05606337599025,
                                "height": 22.412020109689212
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/HAMBURGER_DI_SCOTTONA_MIDELIZIA_1604338648_1619771252.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_diFGzUV_sVnLJiJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "230636",
                            "field1": "Salsiccia Zampina",
                            "field2": "MIDELIZIA",
                            "field3": "g. 360",
                            "field4": "",
                            "description": "Salsiccia Zampina MIDELIZIA g. 360",
                            "grammage": 360,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 52.16236288848263,
                                "left": 48.93357708714199,
                                "width": 24.110298598415604,
                                "height": 22.412020109689212
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/23160_MCS_6389_frontale_10__1594993357_1597305184.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_rt7b51h_RdrPYAV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "181062",
                            "field1": "AMADORI 10+",
                            "field2": "Pollo",
                            "field3": "- 10 Fusi - 10 Sovracosce",
                            "field4": "",
                            "description": "AMADORI 10+ Pollo - 10 Fusi - 10 Sovracosce",
                            "grammage": 0,
                            "price": "2.99",
                            "price_label": "€ 2,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Fusi",
                                "Sovracosce"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 52.16236288848263,
                                "left": 1.1365021328458367,
                                "width": 47.79707495429616,
                                "height": 22.412020109689212
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/pollo_senza_antibiotici_1558004861_1559554082.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/fusi_x10_1620210159.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_fUwRAxM_XjOxb3m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "186661",
                            "field1": "Petto di Pollo BIO",
                            "field2": "FILENI ",
                            "field3": "a Fette",
                            "field4": "g. 250 ca.",
                            "description": "Petto di Pollo BIO FILENI  a Fette g. 250 ca.",
                            "grammage": 0,
                            "price": "13.90",
                            "price_label": "€ 13,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 74.57438299817184,
                                "left": 1.1365021328458367,
                                "width": 47.79707495429616,
                                "height": 21.463665447897622
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/fileni_petto_fette_1612349913.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_Bdm4jrF_qwXKDac.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "88161",
                            "field1": "Cotoletta di Tacchino e Pollo",
                            "field2": "SELEX",
                            "field3": "con Spinaci",
                            "field4": "g. 440",
                            "description": "Cotoletta di Tacchino e Pollo SELEX con Spinaci g. 440",
                            "grammage": 440,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 74.57438299817184,
                                "left": 48.93357708714199,
                                "width": 49.09506398537478,
                                "height": 21.463665447897622
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cotoletta_spinaci_FAM_selex_1491381917.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_UZF8ZIN_m3iQ5FJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_6_Xg9dpGj.jpg",
                    "products": [
                        {
                            "item_id": "230634",
                            "field1": "Burro Senza Lattosio",
                            "field2": "PARMAREGGIO",
                            "field3": "g. 100",
                            "field4": "",
                            "description": "Burro Senza Lattosio PARMAREGGIO g. 100",
                            "grammage": 100,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 3.954453267824497,
                                "left": 3.590417428397319,
                                "width": 31.931748933577087,
                                "height": 22.73765996343693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/58735_ParmareggioBurroSenzaLattosio100gr_1573661975_1574093803_15764_Y2zI8o7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_6o51BPC_MSzTwGh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "26685",
                            "field1": "Parmigiano Reggiano DOP",
                            "field2": "SELEX",
                            "field3": "Grattugiato",
                            "field4": "g. 90",
                            "description": "Parmigiano Reggiano DOP SELEX Grattugiato g. 90",
                            "grammage": 90,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 26.692113231261423,
                                "left": 3.590417428397319,
                                "width": 31.931748933577087,
                                "height": 23.308957952468003
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/parmigiano_reggiano_new_selex_1493971699.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_3UL1OAA_iTHhkIJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "17115",
                            "field1": "Pasta Fresca Ripiena",
                            "field2": "RANA",
                            "field3": "Rustici",
                            "field4": "g. 250",
                            "description": "Pasta Fresca Ripiena RANA Rustici g. 250",
                            "grammage": 250,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 3.954453267824497,
                                "left": 35.5221663619744,
                                "width": 32.784887263863496,
                                "height": 46.04661791590494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/3d-rustici-carne_1581408877.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/3d-rustici-crudo_1581408877.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_DDSyUvp_bcK8hGh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Rana rustici pasta fresca",
                                        "testo": "La sfoglia ruvida, come fatta in casa, avvolge il ripieno più classico della tradizione italiana, amato da grandi e bambini, nel formato di pasta più piccolo e tradizionale. (Fonte: giovannirana.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/3d-rustici-crudo_1581408877.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "25335",
                            "field1": "ACTIVIA ",
                            "field2": "g. 125 x 4",
                            "field3": "",
                            "field4": "",
                            "description": "ACTIVIA  g. 125 x 4",
                            "grammage": 500,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 3.954453267824497,
                                "left": 68.3070536258379,
                                "width": 30.103595368677635,
                                "height": 46.04661791590494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Activia__ZERO_KIWI_1521792000_1522147859_1522227665_1522230284_1527782524.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Activia_foto_fragola_vellutato_x4_1521791998_1522147859_1522227666_1_6KxGgFq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Activia__FRUTTA_PRUGNA_1521791999_1522147858_1522227664_1522230283_1_w8XgkEY.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_yO5hx5u_YGxOBqb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Lintestino_%C3%A8_lepicentro_della_salute__-_Activia_Fibre.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "243699",
                            "field1": "Latte Kefir",
                            "field2": "MILK",
                            "field3": "ml. 480",
                            "field4": "",
                            "description": "Latte Kefir MILK ml. 480",
                            "grammage": 480,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 50.00107118372943,
                                "left": 66.60077696526508,
                                "width": 31.809872029250457,
                                "height": 22.966179159049354
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/450617_MILK_LATTE_KEFIR_ML480_1597661553_1608370089.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_FdiXm1N_JSv400T.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "56188",
                            "field1": "2 Wurstel Servelade",
                            "field2": "RECLA",
                            "field3": "g. 200",
                            "field4": "",
                            "description": "2 Wurstel Servelade RECLA g. 200",
                            "grammage": 200,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.00107118372943,
                                "left": 35.27841255332114,
                                "width": 31.32236441194394,
                                "height": 22.966179159049354
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Recla_wurstel_Servelade_x_2_1427711246.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_YdiDsvw_GplU8Vt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "6082",
                            "field1": "Basi Fresche Rotonde",
                            "field2": "BUITONI",
                            "field3": "g. 230",
                            "field4": "- La Sfoglia - La Brisée",
                            "description": "Basi Fresche Rotonde BUITONI g. 230 - La Sfoglia - La Brisée",
                            "grammage": 230,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "La sfoglia",
                                "La brisée"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.00107118372943,
                                "left": 1.7622638634978671,
                                "width": 33.516148689823275,
                                "height": 22.966179159049354
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/446418_BUITONI_PASTA_BRISEE____GR.230_1593675282.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/446419_BUITONI_SFOGLIA_ROTONDA_GR230_1593675282.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_lrZhtrT_lqrtoZ3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "83851",
                            "field1": "Mascarpone ",
                            "field2": "SELEX",
                            "field3": "g. 500",
                            "field4": "",
                            "description": "Mascarpone  SELEX g. 500",
                            "grammage": 500,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 1.7622638634978671,
                                "width": 33.516148689823275,
                                "height": 23.080438756855578
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Selex_mascarpone_1480527112_1481560445.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_vlaOoUu_iMCZCDW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "48616",
                            "field1": "Pancetta a Cubetti",
                            "field2": "SELEX",
                            "field3": "g. 80 x 2",
                            "field4": "",
                            "description": "Pancetta a Cubetti SELEX g. 80 x 2",
                            "grammage": 160,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 35.27841255332114,
                                "width": 31.32236441194394,
                                "height": 23.080438756855578
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/SELEX_Pancetta_affumicata_80x2_1535386669.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/SELEX_Pancetta_dolce_80x2_1535386670.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_OGg9FYc_5udofxh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "46396",
                            "field1": "Yogurt alla Frutta",
                            "field2": "MIO",
                            "field3": "g. 125 x 2",
                            "field4": "",
                            "description": "Yogurt alla Frutta MIO g. 125 x 2",
                            "grammage": 250,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 66.60077696526508,
                                "width": 32.297379646556976,
                                "height": 23.080438756855578
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Mio_yogurt_banana_125x_2_1619766837.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Mio_yogurt_fragola_125x_2_1619766838.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/nestle_Mio_pera_1619766838.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_DIecszk_QuB9njy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_7_OmqpFRE.jpg",
                    "products": [
                        {
                            "item_id": "171960",
                            "field1": "3 Piadine Romagnola IGP",
                            "field2": "SAPER DI SAPORI",
                            "field3": "g. 360",
                            "field4": "",
                            "description": "3 Piadine Romagnola IGP SAPER DI SAPORI g. 360",
                            "grammage": 360,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 4.640010854661791,
                                "left": 32.10961304082876,
                                "width": 31.687995124923823,
                                "height": 22.052102376599635
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/piadina_romagnola_igp_evo_saper_di_sapori_360g_1529684952_1549015777.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_eqCgoPC_nAP6hK6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "199992",
                            "field1": "Salmone Rosso Selvaggio",
                            "field2": "SAPER DI SAPORI",
                            "field3": "g. 100",
                            "field4": "",
                            "description": "Salmone Rosso Selvaggio SAPER DI SAPORI g. 100",
                            "grammage": 100,
                            "price": "4.69",
                            "price_label": "€ 4,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 4.640010854661791,
                                "left": 63.797608165752585,
                                "width": 32.41925655088361,
                                "height": 22.052102376599635
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/SDS_SALMONE_ROSSO_SELVAGGIO_GR100_1543945518_1574933656.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_ammgEXw_wKb0rM0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "22589",
                            "field1": "NORCINETTO",
                            "field2": "FIORUCCI",
                            "field3": "g. 200 ca.",
                            "field4": "",
                            "description": "NORCINETTO FIORUCCI g. 200 ca.",
                            "grammage": 200,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.692113231261423,
                                "left": 63.797608165752585,
                                "width": 32.41925655088361,
                                "height": 23.19469835466179
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Fiorucci_Norcinetto_DOK_1432227191_1545922856.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/norcinetto_200g_1620140995.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Fiorucci_1620141035.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_rwIx3B6_SQwMZTD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "6122",
                            "field1": "Stracchino",
                            "field2": "SPEGA ",
                            "field3": "g. 100",
                            "field4": "",
                            "description": "Stracchino SPEGA  g. 100",
                            "grammage": 100,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 26.692113231261423,
                                "left": 44.17542656916515,
                                "width": 19.622181596587446,
                                "height": 23.19469835466179
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Spega_stracchino_100_gr.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_QoDrSoP_xzOYYDr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213403",
                            "field1": "Speck Alto Adige IGP",
                            "field2": "SENFTER",
                            "field3": "g. 100",
                            "field4": "",
                            "description": "Speck Alto Adige IGP SENFTER g. 100",
                            "grammage": 100,
                            "price": "2.30",
                            "price_label": "€ 2,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.463594035648992,
                                "left": 23.578229737964655,
                                "width": 20.59719683120049,
                                "height": 23.30895795246801
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/4551_speck-alto-adige-100gr_1508427496_1509098586_1512035525_1537282_UP4C3Wk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_RSVZbhR_OHyVYxi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "61253",
                            "field1": "Prosciutto Cotto Alta Qualità",
                            "field2": "PARMACOTTO",
                            "field3": "g. 100",
                            "field4": "",
                            "description": "Prosciutto Cotto Alta Qualità PARMACOTTO g. 100",
                            "grammage": 100,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 26.463594035648992,
                                "left": 2.0060176721511245,
                                "width": 21.572212065813524,
                                "height": 23.30895795246801
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Prosciutto_Cotto_AQ_1605259762.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_LtEbZXT_n7rtTVu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "59429",
                            "field1": "4 MAXIBON ",
                            "field2": "g. 380",
                            "field3": "",
                            "field4": "",
                            "description": "4 MAXIBON  g. 380",
                            "grammage": 380,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 49.772551988117,
                                "left": 2.0060176721511245,
                                "width": 47.166361974405845,
                                "height": 23.42321755027422
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Maxibon_x4_380g_alta_1464627005_1554135523.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_1Ay1qK4_VWz3Io7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/spot_Maxibon_2016.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "184220",
                            "field1": "5 Bastoncini",
                            "field2": "FINDUS",
                            "field3": "g. 125",
                            "field4": "",
                            "description": "5 Bastoncini FINDUS g. 125",
                            "grammage": 125,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 49.772551988117,
                                "left": 49.172379646556976,
                                "width": 48.9945155393053,
                                "height": 23.42321755027422
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/5_Bastoncini_125g_1561533022_1561563969_1562237455.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_4cmrNq0_KfR8A8y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Findus_Bastoncini_del_Capitano.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "258541",
                            "field1": "Crocchette di Patate ",
                            "field2": "SELEX",
                            "field3": "g. 600",
                            "field4": "",
                            "description": "Crocchette di Patate  SELEX g. 600",
                            "grammage": 600,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 73.19576953839122,
                                "left": 49.172379646556976,
                                "width": 48.9945155393053,
                                "height": 23.080438756855575
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/72336_SLX_CROCCHETTE_DI_PATATE_GR600_1610992410_1619771535.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_MhpgYAX_QHItmzH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "34149",
                            "field1": "4 MaxiStecchi al Latte",
                            "field2": "SELEX",
                            "field3": "g. 350",
                            "field4": "",
                            "description": "4 MaxiStecchi al Latte SELEX g. 350",
                            "grammage": 350,
                            "price": "1.70",
                            "price_label": "€ 1,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 73.19576953839122,
                                "left": 0.9750152346130408,
                                "width": 48.19736441194394,
                                "height": 23.080438756855575
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/selex_maxistecco_350g_1562686105_1587136494.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_TQjoFnf_zMLQIql.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_8_MGNunVp.jpg",
                    "products": [
                        {
                            "item_id": "5741",
                            "field1": "caffè Classico ",
                            "field2": "SAICAF",
                            "field3": "g. 250 x 2",
                            "field4": "",
                            "description": "caffè Classico  SAICAF g. 250 x 2",
                            "grammage": 500,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 3.8401936700182815,
                                "left": 3.7122943327239484,
                                "width": 31.687995124923823,
                                "height": 23.080438756855575
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/BIPACK_classico_10_dic_1594049162.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_8eQgamr_ks9HEoL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "49958",
                            "field1": "Biscotti Integrali",
                            "field2": "GALBUSERA",
                            "field3": "",
                            "field4": "",
                            "description": "Biscotti Integrali GALBUSERA",
                            "grammage": 0,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 26.92063242687385,
                                "left": 3.7122943327239484,
                                "width": 31.687995124923823,
                                "height": 23.19469835466179
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/7055_1619771696.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/27863_1619771697.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/galbusera_turco_400_1619771698.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_Z8n2Bq6_Ejrsg81.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "17076",
                            "field1": "6 Nastrine ",
                            "field2": "MULINO BIANCO",
                            "field3": "g. 240",
                            "field4": "",
                            "description": "6 Nastrine  MULINO BIANCO g. 240",
                            "grammage": 240,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.0687128656307125,
                                "left": 35.40028945764777,
                                "width": 36.07556368068251,
                                "height": 46.04661791590494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Nastrine_6pz_sx_1524497459_1525363008.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Nastrine_cioccolato_6pz_sx_1620141116.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Nastrine_integrali_6pz_sx_1620220444.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_pzPmMxj_aDNpCMX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.mulinobianco.it/nastrine"
                                }
                            ]
                        },
                        {
                            "item_id": "258542",
                            "field1": "Biscuits",
                            "field2": "NUTELLA",
                            "field3": "g. 304",
                            "field4": "",
                            "description": "Biscuits NUTELLA g. 304",
                            "grammage": 304,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 4.0687128656307125,
                                "left": 71.47585313833028,
                                "width": 26.81787020109689,
                                "height": 46.04661791590494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/924658____NUTELLA_BISCUITS_GR.304_1619199354_1619771878.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_53xli4V_wUgsxJQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132414",
                            "field1": "GRAN CEREALE",
                            "field2": "Classico ",
                            "field3": "g. 500",
                            "field4": "",
                            "description": "GRAN CEREALE Classico  g. 500",
                            "grammage": 500,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.22959037934187,
                                "left": 71.71960694698353,
                                "width": 26.81787020109689,
                                "height": 23.08043875685557
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/GC_biscotto_classico_500g_sx_1531928105.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_OGUIwUT_uK1VLS3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5948",
                            "field1": "Estathè ",
                            "field2": "cl. 20 x 3",
                            "field3": "",
                            "field4": "",
                            "description": "Estathè  cl. 20 x 3",
                            "grammage": 600,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 50.22959037934187,
                                "left": 45.7647775746496,
                                "width": 25.954829372333943,
                                "height": 23.08043875685557
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/estathe_tripack_limone_1463577797_1463680149_1490709809_1491896034_1_D4MNV2q.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/stathe_tripack_pesca_1463577858_1491896082_1492686163.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_LRSztYE_IuYKGm6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "12229",
                            "field1": "RINGO",
                            "field2": "g. 165",
                            "field3": "",
                            "field4": "",
                            "description": "RINGO g. 165",
                            "grammage": 165,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.22959037934187,
                                "left": 19.800045703839125,
                                "width": 25.964731870810482,
                                "height": 23.08043875685557
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Ringo_tubo_vaniglia_sx_1588586221.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Ringo_tubo_cacao_sx_1588586224.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_X38lggA_Rr579D7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Ringo__Sempre_al_top.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "202008",
                            "field1": "Drink",
                            "field2": "VALSOIA",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "Drink VALSOIA lt. 1",
                            "grammage": 0,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.22959037934187,
                                "left": 1.8281535648994514,
                                "width": 17.971892138939673,
                                "height": 45.703839122486286
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/soya-classico_1612203396.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/avena-2020_1612203397.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_JgC9nX4_4k8Fd3R.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5992",
                            "field1": "Breakfast",
                            "field2": "SELEX",
                            "field3": "g. 375",
                            "field4": "",
                            "description": "Breakfast SELEX g. 375",
                            "grammage": 375,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 19.800045703839125,
                                "width": 26.025670322973795,
                                "height": 22.966179159049354
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Selex_Vivi_Bene_breakfast_fiocchi_di_riso_375_g.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_r5GEWqa_dX9j99a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "81446",
                            "field1": "Tisane",
                            "field2": "POMPADOUR",
                            "field3": "18/20 Filtri",
                            "field4": "",
                            "description": "Tisane POMPADOUR 18/20 Filtri",
                            "grammage": 0,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 45.82571602681291,
                                "width": 26.015767824497257,
                                "height": 22.966179159049354
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/pompadour_tisana_Finocchio_1481132088_1576752504.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/pompadour_tisana_zenzero_e_limone_20_fl_1541703490_1576752504.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_DUiV3mm_uuXYfcO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "217663",
                            "field1": "Savoiardi",
                            "field2": "SELEX",
                            "field3": "g. 300",
                            "field4": "",
                            "description": "Savoiardi SELEX g. 300",
                            "grammage": 300,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 71.84148385131017,
                                "width": 28.15851614868982,
                                "height": 22.966179159049354
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/savoiardi_selex_300g_1580827029_1595431478.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_jrekb1H_oq5ufYx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_9_KlKAskq.jpg",
                    "products": [
                        {
                            "item_id": "38594",
                            "field1": "Sott'oli di Puglia",
                            "field2": "SAPER DI SAPORI",
                            "field3": "- Carciofi g. 370",
                            "field4": "- Pomodori Essiccati g. 390",
                            "description": "Sott'oli di Puglia SAPER DI SAPORI - Carciofi g. 370 - Pomodori Essiccati g. 390",
                            "grammage": 0,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Carciofi",
                                "Pomodori essiccati"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 3.3831552787934185,
                                "left": 1.7622638634978671,
                                "width": 26.934795856185254,
                                "height": 19.081352833638025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/saper_di_sapori_carciofi_sott_olio_1440427472.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/saper_di_sapori_pomodori_390_1440427481.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_vZmWdKj_FM30k2A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5582",
                            "field1": "Farciriso",
                            "field2": "SELEX",
                            "field3": "g.180",
                            "field4": "- Classico - Senza Olio",
                            "description": "Farciriso SELEX g.180 - Classico - Senza Olio",
                            "grammage": 180,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Senza olio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 3.3831552787934185,
                                "left": 28.697059719683118,
                                "width": 25.59414990859232,
                                "height": 19.081352833638025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/80324591_1523268231.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/80674443_1523268231.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_7XRxm2Z_zvKdbqZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "52966",
                            "field1": "Tonno all’Olio di Oliva ",
                            "field2": "MARE APERTO",
                            "field3": "g. 92 x 3",
                            "field4": "",
                            "description": "Tonno all’Olio di Oliva  MARE APERTO g. 92 x 3",
                            "grammage": 276,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 22.35024851462523,
                                "left": 1.9500304692260817,
                                "width": 40.46313223644119,
                                "height": 19.081352833638025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/77571_1614243397.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_5nxHyvX_W0kXI0p.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5937",
                            "field1": "SIMMENTHAL",
                            "field2": "g. 70 x 3",
                            "field3": "",
                            "field4": "",
                            "description": "SIMMENTHAL g. 70 x 3",
                            "grammage": 210,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 41.43160134826325,
                                "left": 1.9500304692260817,
                                "width": 46.67885435709933,
                                "height": 16.56764168190128
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/191007_SIMMENTHAL-Classica-cluster-Bruschetta-70grx3_1620379074.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_TXvfxQI_5hlQCtP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Simmenthal_Spot_2020_-_15s.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "55365",
                            "field1": "Aceto di Mele",
                            "field2": "SELEX",
                            "field3": "ml. 500",
                            "field4": "",
                            "description": "Aceto di Mele SELEX ml. 500",
                            "grammage": 500,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 23.150065699268737,
                                "left": 48.62888482632542,
                                "width": 12.918951858622785,
                                "height": 34.84917733089579
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/4834613_1619767815.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_H9YMTpG_3M6Zmfj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258544",
                            "field1": "Riso",
                            "field2": "GALLO",
                            "field3": "g. 500",
                            "field4": "- Basmati - Venere",
                            "description": "Riso GALLO g. 500 - Basmati - Venere",
                            "grammage": 500,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Basmati",
                                "Venere"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 25.20673845978062,
                                "left": 61.547836684948194,
                                "width": 34.0036563071298,
                                "height": 32.79250457038391
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/206053_GALLO_RISO_BASMATI_GR.500_1600943762_1619772180.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/206054_GALLO_RISO_VENERE_INTEGR.GR500_1611068753_1619772331.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_FNQqBCS_WWtCNt3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "49961",
                            "field1": "Olio di Semi di Girasole",
                            "field2": "SELEX",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "Olio di Semi di Girasole SELEX lt. 1",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 58.103861974405845,
                                "left": 0.0,
                                "width": 25.490554539914683,
                                "height": 37.95132541133455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/olio_girasole_selex_1478105510_1486369717.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_NQM0ic6_3giydCz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "84162",
                            "field1": "Passata Classica",
                            "field2": "LA FIAMMANTE",
                            "field3": "g. 680",
                            "field4": "",
                            "description": "Passata Classica LA FIAMMANTE g. 680",
                            "grammage": 680,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 58.103861974405845,
                                "left": 25.490554539914683,
                                "width": 23.747714808043874,
                                "height": 37.95132541133455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/La_Fiammante_passata_680g_1441620146.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_leO9bLS_Z4uS1Ss.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5484",
                            "field1": "i Pesti",
                            "field2": "BARILLA",
                            "field3": "g. 190/200",
                            "field4": "",
                            "description": "i Pesti BARILLA g. 190/200",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.10386197440583,
                                "left": 49.23826934795856,
                                "width": 23.053016453382078,
                                "height": 37.95132541133455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Pesto_genovese_190g_it_1547824312_1554136605.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Pesto_genovese_senza_aglio_190g_it_1547824310_1554136605.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_MNXk4FY_iOwoe62.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.barilla.com/it-it/ricerca-prodotti/sauce/gamma/pesti?sort=alpha&page=1"
                                }
                            ]
                        },
                        {
                            "item_id": "258547",
                            "field1": "Gran Bauletto Rustico",
                            "field2": "MULINO BIANCO",
                            "field3": "g. 500",
                            "field4": "",
                            "description": "Gran Bauletto Rustico MULINO BIANCO g. 500",
                            "grammage": 500,
                            "price": "1.90",
                            "price_label": "€ 1,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.103861974405845,
                                "left": 72.29128580134063,
                                "width": 24.600853138330287,
                                "height": 37.95132541133455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Gran_bauletto_rustico_1558948665_1581497148_1619772443.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_XOO2dYj_XF90toF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_10_vDfIwTE.jpg",
                    "products": [
                        {
                            "item_id": "5950",
                            "field1": "Bibite alla Frutta",
                            "field2": "SCHWEPPES",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "Bibite alla Frutta SCHWEPPES lt. 1",
                            "grammage": 0,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 21.32191213436929,
                                "left": 3.590417428397319,
                                "width": 20.59719683120049,
                                "height": 36.563071297989026
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/402389_SCHWEPPES_CEDRATA_LT1_1618479949.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/518228_SCHWEPPES_LIMONE_LT.1_1618479950.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_9Futeur_rSEPiJx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Schweppes.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "258552",
                            "field1": "Gin",
                            "field2": "BOSFORD",
                            "field3": "cl. 70",
                            "field4": "",
                            "description": "Gin BOSFORD cl. 70",
                            "grammage": 700,
                            "price": "8.90",
                            "price_label": "€ 8,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 21.32191213436929,
                                "left": 24.187614259597805,
                                "width": 16.940889701401584,
                                "height": 36.563071297989026
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/bosford_gin_1530107756_1619772788.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_T4DDmGY_j03eNQX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106588",
                            "field1": "Prosecco di Valdobbiadene DOCG",
                            "field2": "BOLLA",
                            "field3": "cl. 75",
                            "field4": "",
                            "description": "Prosecco di Valdobbiadene DOCG BOLLA cl. 75",
                            "grammage": 750,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 21.32191213436929,
                                "left": 41.12850396099939,
                                "width": 17.306520414381474,
                                "height": 36.563071297989026
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/68755__Bolla_Prosecco_DOCG_EXTRA_DRY_1484306019.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_T5Zyoiq_ciTZicu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "248055",
                            "field1": "HEINEKEN  ",
                            "field2": "cl. 25 x 6",
                            "field3": "",
                            "field4": "",
                            "description": "HEINEKEN   cl. 25 x 6",
                            "grammage": 1500,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 24.749700068555757,
                                "left": 58.43502437538086,
                                "width": 22.669104204753197,
                                "height": 33.13528336380256
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Heineken_birra_25_cl_x_6_1611583720_1611764894.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_tOZwYo6_kXVDQKL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Heineken_-_Stanza_della_Birra.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "249261",
                            "field1": "Lupini",
                            "field2": "SALVIANI",
                            "field3": "g. 500",
                            "field4": "",
                            "description": "Lupini SALVIANI g. 500",
                            "grammage": 500,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 24.749700068555757,
                                "left": 81.10412858013407,
                                "width": 17.31147166361975,
                                "height": 33.13528336380256
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/ciotolina_lupini_1435936166_1612948761.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/440196_SALVIANI_LUPINI_SALAMOIA_GR500_1594742275_1612948761.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_svncKyI_W8bSBBU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "114759",
                            "field1": "Frutta secca",
                            "field2": "SELEX ",
                            "field3": "Tostate e Salate ",
                            "field4": "Arachidi/ Pistacchi/ Anacardi",
                            "description": "Frutta secca SELEX  Tostate e Salate  Arachidi/ Pistacchi/ Anacardi",
                            "grammage": 250,
                            "price": "0.00",
                            "price_label": "SCONTO DEL 20% ALLE CASSE",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Arachidi",
                                "Pistacchi",
                                "Anacardi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.182972463436928,
                                "left": 55.022471054235226,
                                "width": 43.39312918951858,
                                "height": 20.56672760511883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Selex_Frutta_Secca_Arachidi_Sgusciate_Tostate_e_Salate_250_g_1554137307.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Selex_Frutta_Secca_Anacardi_Tostati_Salati_200_g_1554137412_PDCLn0L.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Selex_Frutta_Secca_Pistacchi_Tostati_250_g_1554134224_oX2bzck.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_qNt2i0a_RSeZMJw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "192118",
                            "field1": "Bibite",
                            "field2": "SAN PELLEGRINO",
                            "field3": "cl. 20 x 4",
                            "field4": "- Cedrata - Cocktail",
                            "description": "Bibite SAN PELLEGRINO cl. 20 x 4 - Cedrata - Cocktail",
                            "grammage": 800,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cedrata",
                                "Cocktail"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 58.227762225776964,
                                "left": 4.199801950030469,
                                "width": 23.40036563071298,
                                "height": 37.934186471663615
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/1122509_BIBITA_SANPELLEGRINO_20CLX4_CEDRATA_VETR_1562689568_15657734_8KGuW4s.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/1122600_BIBITA_SANPELLEGRINO_20CLX4_CHINO_VETRO_1562689569_156577340_jimX2zH.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_UNTXkhq_7v99uCa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5496",
                            "field1": "Vini IGP",
                            "field2": "TENUTE AL BANO CARRISI",
                            "field3": "cl. 75",
                            "field4": "",
                            "description": "Vini IGP TENUTE AL BANO CARRISI cl. 75",
                            "grammage": 750,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 58.227762225776964,
                                "left": 27.60016758074345,
                                "width": 23.278488726386346,
                                "height": 37.934186471663615
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/villa_carrisi_chardonnay_igp_75_cl_1481799181.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/villa_carrisi_negroamaro_igp_75_cl_1481799181.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/villa_carrisi_primitivo_igp_75_cl_1481799183.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/villa_carrisi_salice_salentino_dop_75_cl_1481799183.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/albano_carrisi_1543577243.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/rosato_negroamaro_carrisi_1481565605_1543943226.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_3xHVjmh_1DfOSvH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5613",
                            "field1": "Birra ",
                            "field2": "DREHER",
                            "field3": "cl. 66",
                            "field4": "",
                            "description": "Birra  DREHER cl. 66",
                            "grammage": 660,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 58.227762225776964,
                                "left": 50.878656307129795,
                                "width": 23.52224253503961,
                                "height": 37.934186471663615
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/birra_dreher_con_gocce_1591784131_1591866044_1591869482_1591950542.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_HhtV7AL_n1ZMEYz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Spot_Dreher-_Lorenzo_Marini_Group.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "244922",
                            "field1": "Acqua Naturale",
                            "field2": "FONTENOCE",
                            "field3": "lt. 2 x 6",
                            "field4": "",
                            "description": "Acqua Naturale FONTENOCE lt. 2 x 6",
                            "grammage": 12000,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 58.227762225776964,
                                "left": 74.40089884216941,
                                "width": 25.59910115783059,
                                "height": 37.934186471663615
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/FARDELLO-FONTENOCE-6X2L_1572544533_1609757239.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/52240_singola_1594980334_1597135420_1609846983.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_lqhoAUB_RnqrylT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_11_EZ4oAaE.jpg",
                    "products": [
                        {
                            "item_id": "171963",
                            "field1": "Detergente Intimo ",
                            "field2": "INFASIL ",
                            "field3": "ml. 200",
                            "field4": "",
                            "description": "Detergente Intimo  INFASIL  ml. 200",
                            "grammage": 0,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 3.4974148765996347,
                                "left": 0.9091255332114565,
                                "width": 24.61913467397928,
                                "height": 46.61791590493602
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/infasil_intima_neutro_1486577124.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_kIg0bx3_dpAZBpS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "18336",
                            "field1": "Sapone Ricarica ",
                            "field2": "FELCE AZZURRA ",
                            "field3": "ml. 750",
                            "field4": "",
                            "description": "Sapone Ricarica  FELCE AZZURRA  ml. 750",
                            "grammage": 0,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 3.4974148765996347,
                                "left": 25.528260207190737,
                                "width": 23.40036563071298,
                                "height": 23.423217550274227
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/sapone_liquido_ricarica_felce_azzura_ml750_1518718963_1518782638.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_YKkY4s6_XFHkQAN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Profumazione",
                                        "testo": "Profumo unico, inconfondibile, composto da più di 100 ingredienti provenienti da tutto il mondo, è tuttora un segreto patrimonio della famiglia Paglieri, contenuto in un prezioso taccuino che viene tramandato di generazione in generazione. (Fonte: felceazzurra.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/EOXc5sZ849/images/sapone_liquido_ricarica_felce_azzura_ml750_1518718963_1518782638.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "22583",
                            "field1": "Shampoo & Balsamo 2in1",
                            "field2": "DIMENSION",
                            "field3": "ml. 250",
                            "field4": "",
                            "description": "Shampoo & Balsamo 2in1 DIMENSION ml. 250",
                            "grammage": 0,
                            "price": "0.80",
                            "price_label": "€ 0,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 26.920632426873862,
                                "left": 25.528260207190737,
                                "width": 23.40036563071298,
                                "height": 23.19469835466179
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/dimension_shampoo_1549290521.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/dimension_capelli_grassi_1549376647.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/dimension_capelli_secchi_1549376649.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_XBsj09A_MAWxwjv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "125794",
                            "field1": "SOLE",
                            "field2": "37/40 Lavaggi",
                            "field3": "",
                            "field4": "",
                            "description": "SOLE 37/40 Lavaggi",
                            "grammage": 0,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 4.182972463436934,
                                "left": 48.928625837903716,
                                "width": 23.8878732480195,
                                "height": 45.932358318098714
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Sole_Liquido_IgieneFreschezza_37_1620221208.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_lxbSGpS_cY0Xh1i.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Sole_detersivo.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "244925",
                            "field1": "PRIL",
                            "field2": "- Brillantante ml. 500",
                            "field3": "- Curalavastoviglie ml. 250",
                            "field4": "",
                            "description": "PRIL - Brillantante ml. 500 - Curalavastoviglie ml. 250",
                            "grammage": 0,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Brillantante",
                                "Curalavastoviglie"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 4.182972463436934,
                                "left": 72.81649908592321,
                                "width": 22.790981109079826,
                                "height": 38.61974405850091
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Pril_Cura_lavastoviglie_1465838822_1557480955_1609757393.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/520463_pril_brillante_500_1610361746.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_2UZouBY_1CQXQKL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "125959",
                            "field1": "SVELTO",
                            "field2": "- gel 36 lavaggi ",
                            "field3": "- 25 tabs tuttoin1 ",
                            "field4": "",
                            "description": "SVELTO - gel 36 lavaggi  - 25 tabs tuttoin1 ",
                            "grammage": 0,
                            "price": "2.89",
                            "price_label": "€ 2,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Gel",
                                "Tabs tutto in 1"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 42.802716521937846,
                                "left": 72.81649908592321,
                                "width": 22.790981109079826,
                                "height": 30.16453382084095
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/svelto_gel_lavastoviglie_1602752128.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/svelto_tabs_1611309780.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_AumP7vU_NkLamIg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5886",
                            "field1": "Contenitori in Alluminio",
                            "field2": "SELEX",
                            "field3": "con Coperchio",
                            "field4": "",
                            "description": "Contenitori in Alluminio SELEX con Coperchio",
                            "grammage": 0,
                            "price": "0.00",
                            "price_label": "SCONTO DEL 20% ALLE CASSE",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 50.34384997714808,
                                "left": 45.51607251675807,
                                "width": 27.30042656916514,
                                "height": 22.62340036563071
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/4_vaschette_in_alluminio_selex_con_coperchio_1580828156_1584689705.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/6_vaschette_in_alluminio_selex_con_coperchio_1580828157_1584689706.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/10_vaschette_in_alluminio_selex_con_coperchio_1580828158_1584689707.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_bxe04Us_4FNj347.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5893",
                            "field1": "Carta Igienica",
                            "field2": "SELEX",
                            "field3": "10 rotoli",
                            "field4": "",
                            "description": "Carta Igienica SELEX 10 rotoli",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 50.34384997714808,
                                "left": 19.800045703839125,
                                "width": 25.71602681291895,
                                "height": 22.62340036563071
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/581035_selex_igienica_1565248886.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_TeTLHmC_V9HgM9e.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "184132",
                            "field1": "Spray Antipuntura",
                            "field2": "SELEX ",
                            "field3": "ml. 100",
                            "field4": "",
                            "description": "Spray Antipuntura SELEX  ml. 100",
                            "grammage": 0,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 50.34384997714808,
                                "left": 1.640386959171237,
                                "width": 18.159658744667887,
                                "height": 22.62340036563071
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/spray_antipuntura_selex_ml._100_1562059796.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_1KWZZW0_txayaOj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258557",
                            "field1": "3 Contenitori",
                            "field2": "BORMIOLI",
                            "field3": "in vetro",
                            "field4": "",
                            "description": "3 Contenitori BORMIOLI in vetro",
                            "grammage": 0,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 1.640386959171237,
                                "width": 70.93235831809872,
                                "height": 22.966179159049357
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/727401_Bormioli_set_3_pz_compact_1_1611661702_1619773264.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/bormioli_1611909242_1619773265.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_YNqlYhf_2YmoaAg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "45636",
                            "field1": " Asciugatutto 2 Veli",
                            "field2": "REGINA DI CUORI",
                            "field3": "3 rotoli",
                            "field4": "",
                            "description": " Asciugatutto 2 Veli REGINA DI CUORI 3 rotoli",
                            "grammage": 0,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 72.96725034277878,
                                "left": 72.57274527726996,
                                "width": 24.13162705667276,
                                "height": 22.966179159049357
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/NUOVA_REGINA_DI_CUORI_1563268254_1571999957_1574873627.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_wy3kRlv_roE6dWl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/page_12_lpR3p06.jpg",
                    "products": [
                        {
                            "item_id": "175257",
                            "field1": "Pasta",
                            "field2": "GAROFALO ",
                            "field3": "g. 500",
                            "field4": "- Formati Speciali - Formati Integrali",
                            "description": "Pasta GAROFALO  g. 500 - Formati Speciali - Formati Integrali",
                            "grammage": 500,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Formati Speciali",
                                "Formati Integrali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 4.0687128656307125,
                                "left": 34.669028031687986,
                                "width": 33.63802559414991,
                                "height": 35.6489945155393
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Garofalo_Calamarata_gr_500.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Garofalo_schiaffoni_gr_500.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/1235_GAROFALO_CASARECCE_INTEGR.G500_1588955302_1590425480.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/garofalo_integrale_500_mezze_maniche_1488384427_1590425480.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_IiJehqS_yQNtJon.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Pasta_Garofalo.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "92424",
                            "field1": "Frollini Classici",
                            "field2": "MULINO BIANCO",
                            "field3": "g. 350/400",
                            "field4": "",
                            "description": "Frollini Classici MULINO BIANCO g. 350/400",
                            "grammage": 0,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.0687128656307125,
                                "left": 68.3070536258379,
                                "width": 29.73796465569774,
                                "height": 35.6489945155393
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Macine_350g_sx2_1506522793_1506603308_1509028966_1509968593_15107587_x9mVFL2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Molinetti_350g_sx_1590427460.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_f0vGYbK_SHWVyqo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/video/Mulino_Bianco_-_Spot_2015_-_Macine_30.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "125840",
                            "field1": "Dressing",
                            "field2": "DEVELEY",
                            "field3": "ml. 230",
                            "field4": "",
                            "description": "Dressing DEVELEY ml. 230",
                            "grammage": 230,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 39.717707381170015,
                                "left": 68.3070536258379,
                                "width": 29.73796465569774,
                                "height": 25.82266910420475
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/principale_4006824993234_1523260883.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/principale_4006824006323_1523260883.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/principale_4006824003216_1523260883.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/488645_1524557693.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_CT6uJ3p_1Hu5jJi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "258558",
                            "field1": "Cipster",
                            "field2": "SAIWA",
                            "field3": "g. 85",
                            "field4": "",
                            "description": "Cipster SAIWA g. 85",
                            "grammage": 85,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 40.63178416361974,
                                "left": 38.93471968312004,
                                "width": 29.372333942717855,
                                "height": 24.90859232175503
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/saiwa_Cipster_astuccio_85_g_1619773415.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_QnCgxvj_240CLII.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "175239",
                            "field1": "Patatine",
                            "field2": "SAPER DI SAPORI",
                            "field3": "g. 150",
                            "field4": "- Classiche - Rosmarino - paprika",
                            "description": "Patatine SAPER DI SAPORI g. 150 - Classiche - Rosmarino - paprika",
                            "grammage": 150,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classiche",
                                "Rosmarino",
                                "Paprika"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 41.43160134826325,
                                "left": 4.199801950030469,
                                "width": 34.73491773308958,
                                "height": 24.108775137111515
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/saper_di_sapori_patatine_rosmarino1_50_gr_1553102605.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/saper_di_sapori_patatine_rosmarino_150_gr_1553102606.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_4BWEZ3A_SMkkjH3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "5498",
                            "field1": "Succhi",
                            "field2": "VALFRUTTA",
                            "field3": "Vari Gusti ",
                            "field4": "lt. 1,5",
                            "description": "Succhi VALFRUTTA Vari Gusti  lt. 1,5",
                            "grammage": 1500,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 65.54037648537476,
                                "left": 4.199801950030469,
                                "width": 24.49725776965265,
                                "height": 24.565813528336378
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/valfrutta_succo_ananas_15_lt.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/valfrutta_succo_ace_15_lt.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_6Xo4GgD_mkZkU4w.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "10739",
                            "field1": "Piselli Finissimi",
                            "field2": "SELEX",
                            "field3": "g. 450",
                            "field4": "",
                            "description": "Piselli Finissimi SELEX g. 450",
                            "grammage": 450,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 65.54037648537476,
                                "left": 28.697059719683118,
                                "width": 23.156611822059716,
                                "height": 24.565813528336378
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/selex_piselli_fini_1579682207.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_8F05n9W_zWmtIb5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "106556",
                            "field1": "Gel",
                            "field2": "SMAC",
                            "field3": "ml. 850",
                            "field4": "- Candeggina - Bagno",
                            "description": "Gel SMAC ml. 850 - Candeggina - Bagno",
                            "grammage": 0,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Candeggina",
                                "Bagno"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 65.54037648537476,
                                "left": 51.85367154174284,
                                "width": 21.69408897014016,
                                "height": 24.565813528336378
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/smac_gel_con_candeggina_1508346694.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/smac_gel_bagno_1508346694.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_qJP6fc5_awtafPS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "239845",
                            "field1": "FABULOSO",
                            "field2": "- Spray ml. 600 ",
                            "field3": "- Pavimenti lt. 1",
                            "field4": "",
                            "description": "FABULOSO - Spray ml. 600  - Pavimenti lt. 1",
                            "grammage": 0,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Spray",
                                "Pavimenti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 65.54037648537476,
                                "left": 73.54776051188298,
                                "width": 23.644119439366232,
                                "height": 24.565813528336378
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Fabuloso_Lavanda_sgrassatore_600_ml_1605891793.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/principale_8714789770031_1598976235_1605891794.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/Fabuloso_pavimenti_lavanda_900100_ml_1620222052.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/products/cropped_image_VSMPU5I_aPIHF4J.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/EOXc5sZ849/pages/Fine-aeo_WHGr8q6.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.aeo;
}

export const serverResponse = lefletSwitch(); 